import classNames from 'classnames';
import React from 'react';
import AlertIcon from 'images/alert.svg';
import InfoIcon from 'images/info-circle.svg';
import WarningIcon from 'images/warning.svg';
import styles from './InfoBox.module.scss';
function InfoBox({ size = 's', type = 'neutral', icon, text, aside, noBorder = false, }) {
    const classes = classNames(styles.wrap, styles[size], styles[type], {
        [styles.noBorder]: noBorder,
    });
    const customIcon = () => {
        if (icon) {
            return icon;
        }
        return {
            success: React.createElement(InfoIcon, null),
            info: React.createElement(InfoIcon, null),
            neutral: React.createElement(InfoIcon, null),
            warning: React.createElement(WarningIcon, null),
            alert: React.createElement(AlertIcon, null),
        }[type];
    };
    return (React.createElement("div", { className: classes },
        React.createElement("p", null,
            customIcon(),
            " ",
            text),
        React.createElement("aside", null, aside)));
}
export default InfoBox;
